export const SAVE_ADDRESS = 'SAVE_ADDRESS';
export const SAVE_ADDRESS_SUCCEED = 'SAVE_ADDRESS_SUCCEED';
export const SAVE_ADDRESS_FAILED = 'SAVE_ADDRESS_FAILED';

export const UPDATE_ADDRESS = 'UPDATE_ADDRESS';
export const UPDATE_ADDRESS_SUCCEED = 'UPDATE_ADDRESS_SUCCEED';
export const UPDATE_ADDRESS_FAILED = 'UPDATE_ADDRESS_FAILED';

export const DELETE_ADDRESS = 'DELETE_ADDRESS';
export const DELETE_ADDRESS_SUCCEED = 'DELETE_ADDRESS_SUCCEED';
export const DELETE_ADDRESS_FAILED = 'DELETE_ADDRESS_FAILED';

export const FETCH_ADDRESS = 'FETCH_ADDRESS';
export const FETCH_ADDRESS_SUCCEED = 'FETCH_ADDRESS_SUCCEED';
export const FETCH_ADDRESS_FAILED = 'FETCH_ADDRESS_FAILED';
